import { t } from 'services/translation';

import './index.scss';
import './PaymentError.scss';

const PaymentError = ({ errorMessage }) => {
  const renderPrimaryMessage = () => {
    if (errorMessage.includes('security code is incorrect.')) {
      return t('YOUR_CARD_SECURITY_CODE_IS_INCORRECT');
    }
    if (errorMessage.includes('Try again in a little bit.')) {
      return t('PLEASE_TRY_AGAIN');
    }

    const regex = /[.,\s]/g;
    const messageAsKey = errorMessage
      .toUpperCase()
      .split(' ')
      .join('_')
      .replace(regex, '');

    const translatedMessage = t(messageAsKey);

    if (translatedMessage === messageAsKey) {
      // We found no key, fallback to the original message
      return errorMessage;
    }

    return translatedMessage;
  };

  return (
    <div className="PaymentError-Container">
      <div className="PaymentError-Message">
        <h1 className="header">{t('PAYMENT_ERROR')}</h1>
        <div className="errorBox">
          <div className="iconBox">
            <i
              className="fa fa-exclamation-triangle"
              aria-hidden="true"
              role="img"
            />
          </div>
          <div className="message">
            <span>{renderPrimaryMessage()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentError;
